// extracted by mini-css-extract-plugin
module.exports = {"message":"ReportsTable_message__AO2D8","phoneNumber":"ReportsTable_phoneNumber__2Amag"};